import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import { Popover, MenuItem } from '@material-ui/core';
import EditSVG from '../../../../../assets/svg/edit';
import CopySVG from '../../../../../assets/svg/copy';
import CancelSVG from '../../../../../assets/svg/cancel';

const ShiftActionsPopover = ({
  anchorEl,
  canPerformEdit,
  onClose,
  onEdit,
  onCopy,
  onDelete,
  ...props
}) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      elevation={1}
      PaperProps={{
        style: {
          width: anchorEl && anchorEl.offsetWidth
        }
      }}
    >
      { canPerformEdit &&
        <MenuItem onClick={onEdit} style={{ display: 'flex' }}>
          <EditSVG />
          <Typography style={{ marginLeft: 16 }}>Edit</Typography>
        </MenuItem>
      }
      <MenuItem onClick={onCopy} style={{ display: 'flex' }}>
        <CopySVG />
        <Typography style={{ marginLeft: 16 }}>Copy</Typography>
      </MenuItem>
      <MenuItem onClick={onDelete} style={{ display: 'flex' }}>
        <CancelSVG />
        <Typography style={{ marginLeft: 16 }}>Delete</Typography>
      </MenuItem>
    </Popover>
  );
};

ShiftActionsPopover.propTypes = {
  anchorEl: PropTypes.instanceOf(Object),
  canPerformEdit: PropTypes.bool,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  onCopy: PropTypes.func,
  onDelete: PropTypes.func
};

export default ShiftActionsPopover;
